var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{staticClass:"modal",attrs:{"closable":false}},[_c('p',[_vm._v("Награда появится в вашем профиле в течение недели")])])}
var staticRenderFns = []

export { render, staticRenderFns }